// export const onAuthSuccess = (state, payload) => {
//   state.auth.token = payload.token;
// };
// export const setBadAttemptToLogIn = (state, payload) => {
//   state.badAttemptToLogIn = payload;
// };
// export const setErrorInfo = (state, payload) => {
//   state.errorInfo = payload;
// };




// export const setProfileData = (state, payload) => {
//   state.auth.user.id = payload.id;
//   state.auth.user.email = payload.email;
//   state.auth.user.first_name = payload.first_name;
//   state.auth.user.last_name = payload.last_name;
//   state.auth.user.role = payload.role;
//   state.auth.user.backup_voip_enable = payload.backup_voip_enable;
//   state.auth.user.voip_user = payload.voip_user;
//   state.auth.user.backup_voip_user = payload.backup_voip_user;
//   state.auth.user.profile_img = payload.profile_img;
//   state.auth.user.team_id = payload.team_id;
//   state.auth.user.seniority = payload.seniority;
//   state.auth.user.user_shifts = payload.user_shifts;
//   state.auth.user.extra = JSON.parse(payload.extra);
// };



// eslint-disable-next-line no-unused-vars
// export const onLogout = (state, payload) => {
//   state.auth.token = "";
//   //state.auth.user = null;
//   state.auth.user.id = null;
//   state.auth.user.email = null;
//   state.auth.user.first_name = null;
//   state.auth.user.last_name = null;
//   state.auth.user.role = null;
//   state.auth.user.backup_voip_enable = null;
//   state.auth.user.voip_user = null;
//   state.auth.user.backup_voip_user = null;
//   state.auth.user.profile_img = null;
//   state.auth.user.team_id = null;
//   state.auth.user.socket_session_id = null;
//   state.auth.user.seniority = null;
//   state.auth.user.user_shifts = [];
//   state.auth.user.extra = {};
// };

// export const setSystemDictionary = (state, payload) => {
//   state.dictionaries.system = payload;
// };




export const setVisitedMainPage = (state, payload) => {
  state.isVisitedMainPage = payload;
};

export const setProfileSocketSessionID = (state, payload) => {
  state.socketSessionId = typeof payload === 'string' ? payload : (payload && payload.socket_session_id) || null;
};
export const setSearchByTaskId = (state, payload) => {
  state.searchByTaskId = payload;
};









export const setClientsTableSelectedTab = (state, payload) => {
  state.clientsTableSelectedTab = payload;
};
export const setClientsTableSelectedMainTab = (state, payload) => {
  state.clientsTableSelectedMainTab = payload;
};

export const setColorBlind = (state, payload) => {
  state.ColorBlind = payload;
};

export const setTotalSumForCrumbBtn = (state, payload) => {
  state.totalSumForCrumbBtn = payload;
};

export const setClientsTableCalendarSubMenuSubMs = (state, payload) => {
  state.clientsTableCalendarSubMenuSubMs = payload;
};
export const setClientsTableStatsObject = (state, payload) => {
  state.clientsTableStatsObject = payload;
};

export const setRefreshAll = (state, payload) => {
  state.refreshAll = payload;
};
export const setOpenCaComponent = (state, payload) => {
  state.openCaComponent = payload;
};
export const setOpenCaComponentOtherDay = (state, payload) => {
  state.openCaComponent.date = payload.date;
};

export const setDebounceAll = (state, payload) => {
  state.DebounceAll = payload;
};
export const setShowReset = (state, payload) => {
  state.showReset = payload;
};

export const setClientsTableCalendarSubMenuOpened = (state, payload) => {
  state.clientsTableCalendarSubMenuOpened = payload;
};
export const setCalNameForCountries = (state, payload) => {
  state.calNameForCountries = payload;
};

// eslint-disable-next-line no-unused-vars

export const setClientsDashBoardQueryParams = (state, payload) => {
  state.ClientsDashBoardQueryParams = payload;
};

export const setEnlargeCompanyTable = (state, payload) => {
  state.enlargeCompanyTable = payload;
};

export const showAddEditUsers = state => {
  state.showAddEditUsers = !state.showAddEditUsers;
};

export const showAddEditBrokers = state => {
  state.showAddEditBrokers = !state.showAddEditBrokers;
};
export const hideAddEditUsers = state => {
  state.showAddEditUsers = false;
};

export const setGeneralDictionary = (state, payload) => {
  state.dictionaries.general = payload;
};



export const setActivityDictionary = (state, payload) => {
  state.dictionaries.activity = payload;
};

export const setSalesPersonList = (state, payload) => {
  state.salesPersonList = payload;
};

export const setClientLogs = (state, payload) => {
  state.clientLogs = payload;
};

export const setKeyWordsDataToCharts = (state, payload) => {
  state.keyWordsDataToCharts = payload;
};

export const setLoading = (state, payload) => {
  state.loading = payload;
};


export const setFilterClientById = (state, payload) => {
  state.filterClientId = payload;
};

export const setFilterFromViki = (state, payload) => {
  state.filterFromViki = payload;
};

export const setFilterClientToCall = (state, payload) => {
  state.filterClientCall = payload;
};
export const setFilterCaMissedClient = (state, payload) => {
  state.filterCaMissed = payload;
};

export const setUpdateDepCharts = (state, payload) => {
  state.updateDepCharts = payload;
};
export const setFilterToMain = (state, payload) => {
  state.FilterToMain[payload.title] = payload.type;
};
export const setRequestForDate = (state, payload) => {
  state.requestForDate = payload;
};

export const setUpdateAfterCongrats = (state, payload) => {
  state.updateAfterCongrats = payload;
};

export const setUpdateLiveChart = (state, payload) => {
  state.updateLiveChart = payload;
};

export const setFilterDepTimeFrame = (state, payload) => {
  state.filterDepTimeFrame = payload;
};

export const setSelectRegCalMonth = (state, payload) => {
  state.selectRegCalMonth = payload;
};
export const setSelectRegCalLastMonth = (state, payload) => {
  state.selectRegCalLastMonth = payload;
};

export const setInitiatedFiltering = (state, payload) => {
  state.initiatedFiltering = payload;
};

export const setChartsMainView = (state, payload) => {
  state.chartsMainView = payload;
};
export const setDpQueryFromMulti = (state, payload) => {
  state.dpQueryFromMulti = payload;
};

export const setAssigmentChartData = (state, payload) => {
  state.AsChartData = payload;
};

export const setAsChartCountries = (state, payload) => {
  state.AsChartCountries = payload;
};

export const setAsChartCountriesData = (state, payload) => {
  state.AsChartCountriesData = payload;
};

export const setAsChartCampaigns = (state, payload) => {
  state.AsChartCampaigns = payload;
};

export const setAsChartCampaignsData = (state, payload) => {
  state.AsChartCampaignsData = payload;
};

export const setDepositClientsFilter = (state, payload) => {
  state.DepositClientsFilter = payload;
};

export const setAssigmentChoseName = (state, payload) => {
  state.AssigmentChoseName = payload;
};
export const setAssigmentChoseActive = (state, payload) => {
  state.AssigmentChoseActive = payload;
};
export const setAssigmentChoseAll = (state, payload) => {
  state.AssigmentChoseAll = payload;
};
export const setAssigmentChoseAllDup = (state, payload) => {
  state.AssigmentChoseAllDup = payload;
};
export const setAssigmentShowCart = (state, payload) => {
  state.AssigmentShowCart = payload;
};
export const setAssigmentChoseTimeForChart = (state, payload) => {
  state.AssigmentChoseTimeForChart = payload;
};

export const setMainDepFilterForThreeMonths = (state, payload) => {
  state.mainDepFilterForThreeMonths = payload;
};

export const setLastModChoseFromStatsTable = (state, payload) => {
  state.LastModChoseFromStatsTable = payload;
};

export const setLastModChoseTimeForChart = (state, payload) => {
  state.LastModChoseTimeForChart = payload;
};

export const SetAssignReportsForMonth = (state, payload) => {
  state.AssignReportsForMonth = payload;
};

export const SetTitleInfo = (state, payload) => {
  state.ForTitleInfo = payload;
};

/*
export const  setTransferConfirmAnswer= (state, payload) => {
  state.transferConfirmAnswer = payload;
};
*/

export const SOCKET_receive_transfer_request_answer = (state, payload) => {
  state.transferConfirmAnswer = payload;
};

export const setTimerOn = (state, payload) => {
  state.timer = payload;
};

export const setQueryFromFavs = (state, payload) => {
  state.dataFromFavs = payload;
};

export const setAddFavToList = (state, payload) => {
  state.addFavToList = payload;
};

export const setDataTimeFiltering = (state, payload) => {
  state.dataTimeFiltering = payload;
};

export const setSelectedStatisticsTimeFrameTab = (state, payload) => {
  state.selectedStatisticsTimeFrameTab = payload;
};

export const setSelectedMainCalendar = (state, payload) => {
  state.selectedMainCalendar = payload;
};

export const setRegCalendarDate = (state, payload) => {
  state.RegCalendarDate = payload;
};
export const setFilterDepStatus = (state, payload) => {
  state.filterDepStatus = payload;
};

export const setMainGraphTabData = (state, payload) => {
  state.mainGraphTabData = payload;
};

export const setGraphDataToTable = (state, payload) => {
  state.graphDataToTable = payload;
};

export const setUpdateDepAfterCongrats = (state, payload) => {
  state.updateDepAfterCongrats = payload;
};

export const setScDataToTable = (state, payload) => {
  state.scDataToTable = payload;
};
export const setRegCalFilterNoDate = (state, payload) => {
  state.regCalFilterNoDate = payload;
};

export const setBNTimer = (state, payload) => {
  state.BNTimer = payload;
};
export const setSCTimer = (state, payload) => {
  state.SCTimer = payload;
};

export const setNITimer = (state, payload) => {
  state.NITimer = payload;
};

export const setClearClientTags = (state, payload) => {
  state.clearClientTags = payload;
};
export const setReOpenMultiCountry = (state, payload) => {
  state.reOpenMultiCountry = payload;
};
export const setGeneralChartFilter = (state, payload) => {
  state.generalChartFilter = payload;
};
export const setClientsTableTab = (state, payload) => {
  state.clientsTableTab = payload;
};
export const setGeneralQueryObject = (state, payload) => {
  state.generalQueryObject = payload;
};
export const setLiveChartDataToCalendar = (state, payload) => {
  state.liveChartDataToCalendar = payload;
};
export const setDynamicChartUsers = (state, payload) => {
  state.dynamicChartUsers = payload;
};
export const setDynamicChartDates = (state, payload) => {
  state.dynamicChartDates = payload;
};
export const setMainCalendarDates = (state, payload) => {
  state.mainCalendarDates = payload;
};
export const setLiveDataFilter = (state, payload) => {
  state.liveDataFilter = payload;
};
export const setSubGraphData = (state, payload) => {
  state.subGraphData = payload;
};
export const setStopProcess = (state, payload) => {
  state.stopProcess = payload;
};
export const setClickedOnMatrixCountries = (state, payload) => {
  state.clickedOnMatrixCountries = payload;
};

export const setMultiSelectChartData = (state, payload) => {
  if (payload[0]) {
    state.multiSelectChartData.data[payload[1]] = payload[0];
    state.multiSelectChartData.fromChart = payload[0].fromChart;
    state.multiSelectChartData.selectedSector = payload[1];
    state.multiSelectChartData.selectedTab = payload[0].selectedTab;
    state.multiSelectChartData.hash = Math.floor(Math.random() * 10000) + 1;;

    if (payload[0].hasOwnProperty("questions")) {
      state.multiSelectChartData.questionsData[payload[0].questions] =
        payload[0];
    }
  } else {
    state.multiSelectChartData = payload;
  }
};

export const setClickFromChart = (state, payload) => {
  state.clickFromChart = payload;
};

export const setCaChartClientId = (state, payload) => {
  state.CaChartClientId = payload;
};

export const setChartsViewBlocks = (state, payload) => {
  state.chartsViewBlocks = payload;
};

export const setSelectedCalendarType = (state, payload) => {
  state.selectedCalendarType = payload;
};
export const setSelectedCalendar = (state, payload) => {
  state.selectedCalendar = payload;
};

export const setSelectedTopTag = (state, payload) => {
  state.selectedTopTag = payload;
};
export const setSelectedTag = (state, payload) => {
  state.selectedTag = payload;
};

export const setCalendarDates = (state, payload) => {
  state.calendarDates = payload;
};

export const setResetOneCalendar = (state, payload) => {
  state.resetCalendar = payload;
};

export const setReqSpecialDates = (state, payload) => {
  state.reqSpecialDates = null;
  state.reqSpecialDates = payload;
};

export const setOpenedTabTag = (state, payload) => {
  state.openedTabTag = payload;
};

export const setNextCallsStats = (state, payload) => {
  state.nextCallsStats = payload;
};
export const setRefreshGeneralLiveSmallStatsChart = (state, payload) => {
  state.refreshGeneralLiveSmallStatsChart = payload;
};

export const setClickOnViki = (state, payload) => {
  state.clickOnViki = payload;
}

